// extracted by mini-css-extract-plugin
module.exports = {"boxLeftx":"Mobiledev_boxLeftx__smPDA","boxRightx":"Mobiledev_boxRightx__19mxv","boxGallery":"Mobiledev_boxGallery__22Yxw"};